import type { AnvilToolHandlerFunction } from '../handler-function-type'
import type {
  ClientToolCall,
  AnvilToolCall,
  AnvilToolOutput,
} from '@anvil/common/tools/list'

export const handleReadUrl = (async (params: {
  previousToolCallFinished: Promise<void>
  toolCall: AnvilToolCall<'read_url'>
  requestClientToolCall: (
    toolCall: ClientToolCall<'read_url'>,
  ) => Promise<AnvilToolOutput<'read_url'>>
}): Promise<{
  output: AnvilToolOutput<'read_url'>
}> => {
  const { previousToolCallFinished, toolCall, requestClientToolCall } = params

  await previousToolCallFinished
  return { output: await requestClientToolCall(toolCall) }
}) satisfies AnvilToolHandlerFunction<'read_url'>
